import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'

import styles from './TagSourceField.less'
import Checkbox from 'lib/control/Checkbox'
import {observer} from "mobx-react";

const {
    'field': field_class,
    'field_with-hint': field_with_hint_class,
    'field-label': label_class,
    'field-label_indented': label_indented_class,
    'field-box': box_class,
    'field-box_flexible': box_flexible_class,
    'field-tag': tag_class,
    'field-tag-arrow': tag_arrow_class,
    'field-tag-label': tag_label_class,
    'value-hint': hint_class,
} = styles

@observer export default class TagSourceField extends Component {
    render() {
        const {
            label,
            tag,
            flexible_content,
            indent_label,
            required,
            hint,
            labelClass,
            contentClass,
            children,
            type,
            /** @type {Field} */
            field
        } = this.props
        const field_classes = [field_class]
        if (hint) {
            field_classes.push(field_with_hint_class)
        }

        const label_classes = [label_class]
        if (labelClass) {
            label_classes.push(labelClass)
        }

        const content_classes = [box_class]
        if (contentClass) {
            content_classes.push(contentClass)
        }

        if (flexible_content) {
            content_classes.push(box_flexible_class)
        }

        if (indent_label) {
            label_classes.push(label_indented_class)
        }

        return (
            <Fragment>
                <div className={field_classes.join(' ')}>
                    <div className={label_classes.join(' ')}>
                        {label}

                        {
                            required ? (
                                <span className={styles['field-required-label']}>*</span>
                            ) : (null)
                        }
                    </div>
                    <div className={content_classes.join(' ')}>{children}</div>
                    <div className={tag_class}>
                        {
                            tag ? (
                                <Fragment>
                                    <div className={tag_arrow_class}>→</div>
                                    <div className={tag_label_class}>{'<'}{tag}{'>'}</div>
                                </Fragment>
                            ) : (null)
                        }
                    </div>
                </div>

                {
                    (!!hint) && <div className={hint_class}>{hint}</div>
                }
                    {type === 'DESCRIPTION' &&
                    <div
                        className={hint_class}
                    >

                        <Checkbox
                            checked={field.strip_tags}
                            onChange={e => {
                                field.strip_tags = e.target.checked
                            }}
                        >Удалить неподдерживаемые Яндекс.Маркет html теги из описания</Checkbox>
                    </div>}
                {type === 'BARCODE' &&
                <div
                    className={hint_class}
                >

                    <Checkbox
                        checked={field.is_validate}
                        onChange={e => {
                            field.is_validate = e.target.checked
                        }}
                    >Валидация штрихкодов</Checkbox>
                </div>}
            </Fragment>
        )
    }
}

TagSourceField.propTypes = {
    label: PropTypes.any,
    tag: PropTypes.any,
    hint: PropTypes.any,
    flexible_content: PropTypes.any,
    indent_label: PropTypes.any,
    labelClass: PropTypes.any,
    contentClass: PropTypes.any,
    required: PropTypes.any
}
